
import JobBoard from './JobBoard';
import JobBoardAccessGate from './JobBoardAccessGate';
import type { MiniAppView } from '../types';
import type { BroUser as JobsBroUser } from './types';
import ErrorBoundary from '@/components/ErrorBoundary';

interface BroUser {
  id: string;
  brocode: string;
  rank: string;
  bro_score: number;
  telegram_id: string | null;
  wallet_address?: string;
  is_brometheus: boolean;
}

interface JobsViewProps {
  user: BroUser;
  onNavigate: (view: MiniAppView) => void;
}

const JobsView = ({ user, onNavigate }: JobsViewProps) => {
  // Simple user transformation - only fix telegram_id issue
  const jobsUser = {
    ...user,
    telegram_id: user.telegram_id ? Number(user.telegram_id) || undefined : undefined,
    created_at: new Date().toISOString(),
    username: user.brocode,
    twitter_handle: undefined
  };

  return (
    <div className="min-h-full">
      <JobBoardAccessGate
        user={jobsUser}
        requiredLevel="browse"
        onVerificationComplete={() => window.location.reload()}
      >
        <JobBoard user={jobsUser} onNavigate={(view: string) => onNavigate(view as MiniAppView)} />
      </JobBoardAccessGate>
    </div>
  );
};

export default JobsView;